import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { FaHandshake, FaClock, FaCertificate, FaSlidersH, FaUsersCog, FaCheckCircle } from 'react-icons/fa';
import {
  SectionTitle,
  SectionSubtitle,
  CardGrid,
  FeatureCard,
  IconCircle,
  FeatureTitle,
  FeatureDescription
} from './WhyChooseUs.styled';

const WhyChooseUs = () => {
  return (
    <Container fluid id="why-choose-us" style={{ padding: '80px 20px' }}>
      <Row style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <SectionTitle>Mengapa Memilih MCup</SectionTitle>
        {/* <SectionSubtitle>
          Our water filtration solutions combine innovation, reliability, and superior performance to
          ensure the cleanest water possible.
        </SectionSubtitle> */}
      </Row>

      <CardGrid>
        <FeatureCard>
          <IconCircle><FaCheckCircle size={18} /></IconCircle>
          <FeatureTitle>Kualitas</FeatureTitle>
          <FeatureDescription>
            Dibuat dari <strong>polypropylene food-grade</strong>, produk kami dirancang untuk keandalan. Produk ini termostabil, tahan suhu dari <strong>-5°C hingga 100°C</strong>, menjadikannya aman dan efektif untuk berbagai aplikasi.
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <IconCircle><FaClock size={18} /></IconCircle>
          <FeatureTitle>Keandalan</FeatureTitle>
          <FeatureDescription>
            Dapatkan <strong>kualitas produk yang seragam</strong> dan <strong>dimensi yang presisi</strong> di setiap pesanan. Logistik dan perencanaan produksi kami yang kuat menjamin pengiriman tepat waktu, menjadikan kami mitra yang dapat Anda andalkan.
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <IconCircle><FaHandshake size={18} /></IconCircle>
          <FeatureTitle>Kemitraan</FeatureTitle>
          <FeatureDescription>
            Kami berkomitmen untuk menjadi <strong>mitra jangka panjang yang andal</strong>, siap mendukung pertumbuhan bisnis Anda di tahun-tahun mendatang. Dedikasi kami melampaui satu transaksi untuk membangun hubungan yang langgeng.
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <IconCircle><FaCertificate size={18} /></IconCircle>
          <FeatureTitle>Kepatuhan</FeatureTitle>
          <FeatureDescription>
            Beroperasi dengan percaya diri karena produk kami memiliki <strong>Sertifikasi FSSC 22000</strong> dan <strong>Sertifikasi Halal</strong>. Kami mematuhi standar keamanan dan kualitas makanan yang diakui secara global, memberikan Anda ketenangan pikiran.
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <IconCircle><FaSlidersH size={18} /></IconCircle>
          <FeatureTitle>Kustomisasi</FeatureTitle>
          <FeatureDescription>
            Bebaskan kreativitas Anda dengan opsi <strong>custom fit</strong> kami. Anda dapat menyesuaikan <strong>ukuran, bentuk, warna, dan cetakan</strong> agar sangat sesuai dengan kebutuhan merek dan produk Anda.
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <IconCircle><FaUsersCog size={18} /></IconCircle>
          <FeatureTitle>Kolaborasi</FeatureTitle>
          <FeatureDescription>
            Dari konsep hingga kreasi, tim kami memberikan <strong>dukungan langsung</strong> untuk desain cetakan khusus Anda. Kami bekerja sama dengan Anda untuk mewujudkan visi Anda, memastikan kesesuaian yang sempurna untuk kebutuhan unik Anda.
          </FeatureDescription>
        </FeatureCard>
      </CardGrid>
    </Container>
  );
};

export default WhyChooseUs;
